import { render } from "./PopForm.vue?vue&type=template&id=2e017f83&scoped=true"
import script from "./PopForm.vue?vue&type=script&lang=js"
export * from "./PopForm.vue?vue&type=script&lang=js"

import "./PopForm.vue?vue&type=style&index=0&id=2e017f83&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e017f83"]])

export default __exports__